import React from 'react'

function TechSndj() {
  return (
    <embed src="\pdfs\E2.3.2_nd-j_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSndj